const firebase = require('firebase/app');
require('firebase/database');

var config = {
    apiKey: 'AIzaSyDZa1FuM2NEInEQIPIybGAh4L66LczCjRM',
    authDomain: 'lol-datax.firebaseapp.com',
    databaseURL: 'https://lol-datax.firebaseio.com',
    projectId: 'lol-datax',
    storageBucket: 'lol-datax.appspot.com',
    messagingSenderId: '719528951527'
};

firebase.initializeApp(config);

const _ = require('lodash');

const database = firebase.database();

const draftsRef = database.ref('/drafts'),
    newsRef = database.ref('/news'),
    playersStatsRef = database.ref('/playerStats'),
    goldsDiffRef = database.ref('/golds')

export default {
    getDrafts: function(region, year, tournament) {
        return new Promise((resolve) => {
            draftsRef.child(region).orderByChild('orderKey')
                .equalTo(year + '_' + tournament).once('value', snapshot => {
                    let drafts = _.toArray(snapshot.val());

                    resolve(_.sortBy(drafts, draft => {
                        return -draft.date;
                    }));
                });
        });
    },
    getNews: function() {
        return new Promise((resolve) => {
            newsRef.once('value', snapshot => {
                let regionsNews = _(snapshot.val()).map((region, key) => {
                    return {
                        name: key,
                        drafts: _.sortBy(region.drafts, draft => {
                            return -draft.date;
                        }),
                        playersStats: region.playerStats
                    };
                }).sortBy('name').value();

                resolve(regionsNews);
            });
        });
    },
    getPlayersStats: function(region, year, tournament) {
        return new Promise((resolve) => {
            playersStatsRef.child(region).child(year + '_' + tournament).once('value', snapshot => {
                let stats = snapshot.val();

                resolve(stats);
            });
        })
    },
    getGoldsDiff: function(region, year, tournament) {
        return new Promise(resolve => {
            goldsDiffRef.child(region).child(year + '_' + tournament).once('value', snapshot => {
                let goldsDiff = snapshot.val();

                resolve(goldsDiff);
            });
        });
    }
}